module.exports = {"pathContext":{"name":"LabOrderDetail","kind":"UNION","type":"OBJECT","fields":null,"description":"Integration-specific details for a lab order.","enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"FujirisLabOrderDetail","ofType":null},{"kind":"OBJECT","name":"HarvestLabOrderDetail","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/union-lab-order-detail.json
// module id = 2141
// module chunks = 60914776476172